export const colors = {
    primaryColor: '#2a57aa',
    secondColor: '#14326a',
    tertiaryColor: '#fff', 
}